import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingGrid from './components/TrendingGrid';
import DailyCompetition from './components/DailyCompetition';
import CtaSection from './components/CtaSection';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

const homepageJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://51chigua.com/#organization",
      "name": "51吃瓜App",
      "url": "https://51chigua.com",
      "description": "51吃瓜app下载聚合页，提供51吃瓜app网站最新入口与51吃瓜app官网导航。覆盖今日网红吃瓜黑料、明星爆料实时更新，整合51吃瓜在线观看和每日大赛热门资源，一站直达现场。",
      "foundingDate": "2020",
      "logo": "https://51chigua.com/logo.png",
      "sameAs": [
        "https://weibo.com/51chigua",
        "https://weixin.qq.com"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "email": "contact@51chigua.com",
        "telephone": "+86-400-888-5151",
        "availableLanguage": "Chinese"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://51chigua.com/#website",
      "url": "https://51chigua.com",
      "name": "51吃瓜App",
      "description": "51吃瓜app下载聚合页，提供51吃瓜app网站最新入口与51吃瓜app官网导航。",
      "publisher": { "@id": "https://51chigua.com/#organization" },
      "inLanguage": "zh-CN",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://51chigua.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://51chigua.com/#webpage",
      "url": "https://51chigua.com",
      "name": "51吃瓜app-51吃瓜app下载与51吃瓜app网站 | 每日吃瓜黑料爆料追踪",
      "description": "51吃瓜app下载聚合页，提供51吃瓜app网站最新入口与51吃瓜app官网导航。覆盖今日网红吃瓜黑料、明星爆料实时更新，整合51吃瓜在线观看和每日大赛热门资源，一站直达现场。",
      "isPartOf": { "@id": "https://51chigua.com/#website" },
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": "https://readdy.ai/api/search-image?query=Modern%20entertainment%20news%20portal%20with%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20abstract%20artistic%20style%2C%20editorial%20composition%2C%20rich%20content%20layout%2C%20dark%20moody%20aesthetic&width=1200&height=630&seq=home-og&orientation=landscape",
        "width": "1200",
        "height": "630"
      },
      "inLanguage": "zh-CN"
    }
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }}
      />
      <title>51吃瓜app-51吃瓜app下载与51吃瓜app网站 | 每日吃瓜黑料爆料追踪</title>
      <meta name="description" content="51吃瓜app下载聚合页，提供51吃瓜app网站最新入口与51吃瓜app官网导航。覆盖今日网红吃瓜黑料、明星爆料实时更新，整合51吃瓜在线观看和每日大赛热门资源，一站直达现场。" />
      <link rel="canonical" href="https://51chigua.com" />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-primary-500/10 text-primary-600 rounded-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                    </div>
                    <span className="font-medium text-sm md:text-base text-foreground-900 whitespace-nowrap">
                      {cat.name}
                    </span>
                    <span className="text-foreground-500 text-xs">
                      {cat.articleCount}篇文章
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <TrendingGrid />
          <DailyCompetition />

          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
                <div>
                  <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                    51吃瓜视频
                  </h2>
                  <p className="text-foreground-600 text-sm md:text-base mt-2">
                    热门吃瓜事件视频合集，高清在线观看最新爆料现场
                  </p>
                </div>
                <Link
                  to="/category/video"
                  className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  更多视频
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                <Link
                  to="/article/video-001"
                  className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer transition-transform duration-300 hover:-translate-y-1"
                >
                  <div className="relative w-full aspect-video overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20modern%20editorial%20style%2C%20cinematic%20composition%20with%20soft%20depth%20of%20field%2C%20abstract%20artistic%20aesthetic%2C%20clean%20minimal%20design%2C%20no%20text%20no%20watermark&width=800&height=450&seq=video-thumb-001&orientation=landscape"
                      alt="51吃瓜视频 - 独家视频：某流量明星后台发飙"
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-full group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-play-fill text-2xl md:text-3xl ml-1"></i>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading font-semibold text-foreground-900 line-clamp-2 text-sm md:text-base">
                      独家视频：某流量明星后台发飙全程录像曝光，场面一度失控
                    </h3>
                    <p className="mt-2 text-foreground-500 text-xs">
                      2026-07-06 · 51吃瓜视频
                    </p>
                  </div>
                </Link>

                <Link
                  to="/article/video-002"
                  className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer transition-transform duration-300 hover:-translate-y-1"
                >
                  <div className="relative w-full aspect-video overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20modern%20editorial%20style%2C%20cinematic%20composition%20with%20soft%20depth%20of%20field%2C%20abstract%20artistic%20aesthetic%2C%20clean%20minimal%20design%2C%20no%20text%20no%20watermark&width=800&height=450&seq=video-thumb-002&orientation=landscape"
                      alt="51吃瓜视频 - 网红直播间惊人一幕"
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-full group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-play-fill text-2xl md:text-3xl ml-1"></i>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading font-semibold text-foreground-900 line-clamp-2 text-sm md:text-base">
                      网红直播间惊人一幕：助理不小心拍到后台真实场景
                    </h3>
                    <p className="mt-2 text-foreground-500 text-xs">
                      2026-07-05 · 51吃瓜视频
                    </p>
                  </div>
                </Link>

                <Link
                  to="/article/video-003"
                  className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer transition-transform duration-300 hover:-translate-y-1"
                >
                  <div className="relative w-full aspect-video overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20modern%20editorial%20style%2C%20cinematic%20composition%20with%20soft%20depth%20of%20field%2C%20abstract%20artistic%20aesthetic%2C%20clean%20minimal%20design%2C%20no%20text%20no%20watermark&width=800&height=450&seq=video-thumb-003&orientation=landscape"
                      alt="51吃瓜视频 - 综艺录制现场突发状况"
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-full group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-play-fill text-2xl md:text-3xl ml-1"></i>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading font-semibold text-foreground-900 line-clamp-2 text-sm md:text-base">
                      实拍直击：某综艺录制现场突发状况，明星反应亮了
                    </h3>
                    <p className="mt-2 text-foreground-500 text-xs">
                      2026-07-04 · 51吃瓜视频
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          <CtaSection />
        </main>
        <Footer />
      </div>
    </>
  );
}